import { IconButton, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { useCallback, useState } from "react";
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useNavigate } from "react-router-dom";
import { GetCalculatorInfo } from "../../context/calculator/tour/calculatorProvider";
import { GetPastTrips } from "../../context/trip/tripProvider";
import { GetSitesAndActivityInfo } from "../../context/calculator/sitesAndActivity/sitesAndActivityProvider";

export const navOptions = [
    {id: 0, icon: <ListAltOutlinedIcon />, label: "Records", link: "/records"},
    {id: 1, icon: <FmdGoodOutlinedIcon />, label: "Map", link: "/map"},
    {id: 2, icon: <RateReviewOutlinedIcon />, label: "Calculator", link: "/calculator?type=tours"},
    {id: 3, icon: <PersonOutlineOutlinedIcon />, label: "Profile", link: "/profile"}
];

const WebNavigationComponent = ({defaultIndex = 0}) => {
    const [value, setValue] = useState(defaultIndex);

    const navigate = useNavigate();

    const tripInfo = GetCalculatorInfo();
    const siteAndActivityInfo = GetSitesAndActivityInfo();

    const {clearActiveTour, clearEditTourHistory} = GetPastTrips();

    const selectPages = useCallback((newValue, link) => {
        setValue(newValue);

        if(defaultIndex === newValue) return;

        tripInfo?.clearCalculator();
        clearActiveTour();
        clearEditTourHistory();

        siteAndActivityInfo?.clearCalculator();
        siteAndActivityInfo?.clearEditSitesAndActivityHistory();

        navigate(link);
    }, [tripInfo]);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                top={0}
                left={0}
                height='100vh'
                sx={{
                    position: 'fixed',
                    display: {xs: 'none', lg: 'block'}
                }}
                pt={7}
                px={4}
                bgcolor='white'
                width='15px'
                spacing={8}
            >
                {
                    navOptions.map((item, index) => {
                        return <NavOption 
                            key={index}
                            item={item}
                            value={value}
                            selectPages={selectPages}
                        />
                    })
                }
            </Stack>
        </>
    );
}

export default WebNavigationComponent;

const NavOption = ({
    item,
    value,
    selectPages
}) => {
    const theme = useTheme();

    return (
        <>
            <Tooltip title={item.label}>
                <IconButton 
                    sx={{
                        width: '100%',
                        height: '35px',
                        color: value === item.id ? theme.palette.primary.main : '#000000'
                    }}
                    onClick={() => selectPages(item.id, item.link)}
                    disableRipple
                >
                    <Stack
                        direction='column'
                        alignItems='center'
                    >
                        {item.icon}

                        <Typography
                            fontSize={12}
                        >
                            {item.label}
                        </Typography>
                    </Stack>
                </IconButton>
            </Tooltip>
        </>
    );
}